"use client";

import ValuePropsSection from ".";
import { defaultSectionValuePropsData } from "./default";
import type { BaseValuePropsSectionData } from "./types";

interface BaseValuePropsSectionProps {
  data?: BaseValuePropsSectionData;
}

export default function BaseValuePropsSection({
  data = defaultSectionValuePropsData,
}: BaseValuePropsSectionProps) {
  if (!data.cards?.length) return null;

  return (
    <ValuePropsSection
      title={data.title}
      subtitle={data.subtitle}
      cards={data.cards}
      elementName={data.elementName}
      mobileLayout={data.mobileLayout}
      mobileListIconPlacement={data.mobileListIconPlacement}
      backgroundColor={data.backgroundColor}
      cardStyle={data.cardStyle}
      cardLayout={data.cardLayout}
      ctaGroup={data.ctaGroup}
      legal={data.legal}
      featuredImage={data.featuredImage}
      tagularProps={data.tagularProps}
    />
  );
}
